import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api, uid } from "../lib/api";

const RegistrationContext = createContext(null);
export const useRegistration = () => useContext(RegistrationContext);

const emptyServices = () => ({
  football: { type: "none", days: {} },
  goalkeeper: { type: "none", days: {} },
  feedback: { type: "none", days: {} },
  development_package: false,
  meals: { days: [] },
});

export const emptyParticipant = () => ({
  _k: uid("p"),
  first_name: "", last_name: "", dob: "", gender: "",
  tshirt_size: "", shorts_size: "", socks_size: "",
  medical_none: true, medical_details: "",
  meal_dietary: "",
  services: emptyServices(),
});

const emptyGuardian = () => ({
  first_name: "", last_name: "", email: "", phone: "", country: "", marketing_consent: false,
});

const QUOTE_FIELDS = ["first_name", "last_name", "dob", "gender", "tshirt_size", "shorts_size", "socks_size"];
const quotable = (parts) => parts.every((p) => QUOTE_FIELDS.every((f) => String(p[f] || "").trim()));

export function RegistrationProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [participants, setParticipants] = useState([emptyParticipant()]);
  const [guardian, setGuardian] = useState(emptyGuardian());
  const [consents, setConsents] = useState({
    guardian_confirm: false, terms: false, privacy: false, medical_share: false,
  });
  const [giftRecipientIndex, setGiftRecipientIndex] = useState(0);
  const [quote, setQuote] = useState(null);

  const loadConfig = useCallback(async () => {
    const { data } = await api.get("/config/public");
    setConfig(data);
  }, []);

  useEffect(() => { loadConfig(); }, [loadConfig]);

  const refreshQuote = useCallback(async (parts) => {
    try {
      const { data } = await api.post("/quote", { participants: parts || participants });
      setQuote(data);
      return data;
    } catch (e) {
      setQuote(null);
      return null;
    }
  }, [participants]);

  useEffect(() => {
    if (!quotable(participants)) { setQuote(null); return undefined; }
    const t = setTimeout(() => { refreshQuote(participants); }, 250);
    return () => clearTimeout(t);
  }, [participants, refreshQuote]);

  const value = {
    config, loadConfig,
    participants, setParticipants,
    guardian, setGuardian,
    consents, setConsents,
    giftRecipientIndex, setGiftRecipientIndex,
    quote, refreshQuote,
  };
  return <RegistrationContext.Provider value={value}>{children}</RegistrationContext.Provider>;
}
